import { render, staticRenderFns } from "./ShopDetail.vue?vue&type=template&id=f3027e6c&"
import script from "./ShopDetail.vue?vue&type=script&lang=js&"
export * from "./ShopDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3027e6c')) {
      api.createRecord('f3027e6c', component.options)
    } else {
      api.reload('f3027e6c', component.options)
    }
    module.hot.accept("./ShopDetail.vue?vue&type=template&id=f3027e6c&", function () {
      api.rerender('f3027e6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "modules/shop/finder/components/ShopDetail.vue"
export default component.exports